import { render, staticRenderFns } from "./IconBoxContent.vue?vue&type=template&id=9df94cd8&scoped=true&"
import script from "./IconBoxContent.vue?vue&type=script&lang=ts&"
export * from "./IconBoxContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df94cd8",
  null
  
)

export default component.exports